import { RouteBuilders } from "@simplyk/common";
import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";

import { useLiveFormEditorContext } from "../common/LiveFormEditorContext";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useUrlBuilder } from "@/common/hooks/useUrlBuilder";

export const ON_EXIT_URL_QUERY_PARAM = "onExitUrl";

const isRelativeUrl = (url: string): boolean => url.startsWith("/") && !url.startsWith("//");

export const useLiveFormEditorExit = () => {
  const router = useRouter();
  const buildUrl = useUrlBuilder();
  const { isoLocale } = useLocaleContext();
  const searchParams = useSearchParams();
  const { defaultExitUrl } = useLiveFormEditorContext();

  const rawOnExitUrl = searchParams.get(ON_EXIT_URL_QUERY_PARAM);
  const campaignListUrl = buildUrl({
    route: RouteBuilders.buildCampaignListLink({ isoLocale }),
  });

  const fallbackUrl = defaultExitUrl ?? campaignListUrl;
  const exitUrl = (rawOnExitUrl && isRelativeUrl(rawOnExitUrl) ? rawOnExitUrl : null) ?? fallbackUrl;

  const exitLiveFormEditor = async () => {
    await router.push(exitUrl);
  };

  // Intentionally skips `onExitUrl` — used after deleting the form to avoid navigating
  // to a URL that may reference it (e.g. the deleted form's campaign hub).
  const exitAfterFormDeletion = async () => {
    await router.push(fallbackUrl);
  };

  return { exitLiveFormEditor, exitAfterFormDeletion };
};
